/**
 * CRAFTFINDUS wordmark with brand colors.
 * "CRAFT" in foreground, "FINDUS" in accent (copper/orange).
 * Use inline within any text context.
 */
const Brand = () => (
  <span className="whitespace-nowrap">
    CRAFT<span className="text-accent">FINDUS</span>
  </span>
);

export default Brand;
